import { useSelector } from "react-redux";
import { RootState } from "../../redux/store/store";

const useMondayContext = () => {
  const { appVersionId, appVersion, appFeatureType, appFeatureId, approvedScopes, requiredScopes } = useSelector(
    (state: RootState) => state.monday,
  );

  return {
    appVersionId,
    appVersion,
    appFeatureType,
    appFeatureId,
    approvedScopes,
    requiredScopes,
  };
};

export default useMondayContext;
